
const imgs = {
  days: {
    inactive: 'days',
    crit: 'critDays',
    bad: 'badDays',
    good: 'goodDays'
  },
  ttp: {
    inactive: 'ttp',
    crit: 'critTtp',
    bad: 'badTtp',
    good: 'goodTtp'
  },
  hhm: {
    inactive: 'hhm',
    crit: 'critHhm',
    bad: 'badHhm',
    good: 'goodHhm'
  },
  iaq: {
    inactive: 'iaq',
    crit: 'iaqRed',
    bad: 'iaqYellow',
    good: 'iaqGreen'
  },
  co2: {
    inactive: 'co2',
    crit: 'critCo2',
    bad: 'badCo2',
    good: 'goodCo2'
  },
  voc: {
    inactive: 'nuevoVOC',
    crit: 'nuevoVOC',
    bad: 'nuevoVOC',
    good: 'nuevoVOC'
  },
  deltaPressure95Percentile: {
    inactive: '',
    crit: '',
    bad: '',
    good: ''
  }
}

export default {

  parseThresh(alerts, rdg, inactive){
    let thresh = {};
    if (inactive) {
      thresh.color = 'white';
      thresh.img = imgs[rdg].inactive;
    } else {
      if (alerts[rdg]) {
        if (alerts[rdg].crit > 0) {
          thresh.color = '#f32b43';
          thresh.img = imgs[rdg].crit;
        } else if (alerts[rdg].bad > 0) {
          thresh.color = '#f6d857';
          thresh.img = imgs[rdg].bad;
        } else {
          thresh.color = '#96fa87';
          thresh.img = imgs[rdg].good;
        }
      }
    }
    thresh.img = `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${thresh.img}.png`;
    return thresh;
  }

}



// WEBPACK FOOTER //
// ./src/lib/threshParser.js